import React, { useId } from 'react';
import { IconWithGradient } from 'design-system/icons/Icon';
import { Rect } from 'react-native-svg';
export const IconBoldDrag = (props) => {
    const id = useId();
    return (<IconWithGradient id={id} {...props} defaultGradientKey="apricot" colorKey="secondary">
      <Rect x="5" y="8" width="14" height="2" rx="1" fill={`url(#gradient_${id})`}/>
      <Rect x="5" y="13" width="14" height="2" rx="1" fill={`url(#gradient_${id})`}/>
    </IconWithGradient>);
};
